/* ------------------------------------------------------------------
   instructionsSlice.js  // NEW
   - Mirrors Instruction model in Mongo
   - Holds ALL instruction docs in Redux
   - Provides helpers to set, upsert, and update text
------------------------------------------------------------------ */

import { createSlice, createEntityAdapter, createSelector } from '@reduxjs/toolkit';

/* NEW: normalized adapter for instructions */
const instructionsAdapter = createEntityAdapter({
  selectId: (instr) => instr._id, // Mongo _id
  sortComparer: (a, b) => (a.updatedAt || '').localeCompare(b.updatedAt || ''),
});

/* NEW: initial state */
const initialState = instructionsAdapter.getInitialState({
  lastLoadedAt: null,
});

/* NEW: slice */
const instructionsSlice = createSlice({
  name: 'instructions',
  initialState,
  reducers: {
    /* Replace all (e.g., on login/refresh load) */
    setAllInstructions: (state, action) => {
      instructionsAdapter.setAll(state, action.payload || []);
      state.lastLoadedAt = Date.now();
    },

    /* Upsert a single instruction doc */
    upsertInstruction: (state, action) => {
      instructionsAdapter.upsertOne(state, action.payload);
    },

    /* Update just the instructionText (local echo) */
    updateInstructionText: (state, action) => {
      const { _id, instructionText } = action.payload || {};
      if (_id) {
        instructionsAdapter.updateOne(state, {
          id: _id,
          changes: { instructionText },
        });
      }
    },
  },
});

export const {
  setAllInstructions,     // NEW
  upsertInstruction,      // NEW
  updateInstructionText,  // NEW
} = instructionsSlice.actions;

/* ---------- Selectors (NEW) ---------- */
const baseSelector = (state) => state.instructions;
export const {
  selectAll: selectAllInstructions,
  selectById: selectInstructionById,
  selectIds: selectInstructionIds,
} = instructionsAdapter.getSelectors(baseSelector);

/* NEW: filter by type (company | workflow | object) */
export const makeSelectInstructionsByType = (type) =>
  createSelector(selectAllInstructions, (all) => all.filter((i) => i.type === type));

/* NEW: first "company" instruction (simple default for Company tab) */
export const selectFirstCompanyInstruction = createSelector(
  selectAllInstructions,
  (all) => all.find((i) => i.type === 'company') || null
);

export default instructionsSlice.reducer;